import { Input, Component, OnInit, OnDestroy } from '@angular/core';
import { GridPagerService } from 'src/app/core/services/grid-pager.service';

@Component({
  selector: 'grid-pager',
  templateUrl: './grid-pager.component.html',
  styleUrls: ['./grid-pager.component.scss']
})
export class GridPagerComponent implements OnInit, OnDestroy {
	@Input() pageableItems:any = [];

    hasItems: boolean = false;

	currentPageNumber: any = 1;
	totalPages: any = 0;
    pages: any = [];
    pageSize: any = 10;

    showPrevious: boolean = false;
    showNext: boolean = false;
    refreshPagingEvent: any;
	
	constructor(
		public gridPagerService: GridPagerService) {

		this.gridPagerService.pagerInitialized = true;

		this.refreshPagingEvent = this.gridPagerService.refreshPagingEvent.subscribe((data)=>{
			this.pageableItems = data;

			this.generatePagingData();
		});				
	}

	ngOnInit() {
		//console.log("ngOnInit")
	}

	ngOnDestroy() {
		this.refreshPagingEvent.unsubscribe();
	}

	changePageSize(){
		this.currentPageNumber = 1;
		
		this.gridPagerService.clickPageEvent.next({page: this.currentPageNumber, size: this.pageSize});	
	}

	goPrevious(){
		if(this.gridPagerService.isLoading) return;

		this.currentPageNumber = this.currentPageNumber-1;

		this.gridPagerService.clickPageEvent.next({page: this.currentPageNumber, size: this.pageSize});	
	}

	goNext(){
		if(this.gridPagerService.isLoading) return;

		this.currentPageNumber = this.currentPageNumber+1;

		this.gridPagerService.clickPageEvent.next({page: this.currentPageNumber, size: this.pageSize});	
	}	

	changePage(page){
		if(this.gridPagerService.isLoading) return;

		this.gridPagerService.clickPageEvent.next({page: page, size: this.pageSize});	
	}

	generatePagingData(){
		this.hasItems = (this.pageableItems.length == 0 && this.currentPageNumber == 1) ? false : true;
		this.pages = [];

		if(this.hasItems){
			this.currentPageNumber = this.pageableItems[0].PageNumber;
			this.totalPages = this.pageableItems[0].TotalPages;

			//First page / only one item
			if(this.currentPageNumber==1 && this.currentPageNumber == this.totalPages){
				this.showPrevious = false;
				this.showNext = false;
			}

			//First page / multiple pages
			else
			if(this.currentPageNumber == 1 && this.totalPages>1){
				this.showPrevious = false;
				this.showNext = true;
			}	

			//Middle page
			else
			if(this.currentPageNumber > 1 && this.totalPages>this.currentPageNumber){
				this.showPrevious = true;
				this.showNext = true;
			}	

			// Last page
			else
			if(this.currentPageNumber > 1 && this.totalPages==this.currentPageNumber){
				this.showPrevious = true;
				this.showNext = false;
			}	
			
			var start = Math.max(1, this.currentPageNumber - 2)
			var end = Math.min(start + 5, this.totalPages)

			for (var i = start; i <= end; i++) {
			  this.pages.push(i);
			}
		}else{
			this.showPrevious = false;
			this.showNext = false;
	    	this.pages = [];
		}		
	}
}
